<script setup lang="ts">

</script>

<template>
  <div class="min-h-screen bg-gray-50">
    <slot />
  </div>
</template>
